export const apiUrl = "https://make-a-scene-backend.herokuapp.com";
export const feedbackMessageDuration = 5000;
